import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import useSEO from "@/hooks/useSEO";

const NotFound = () => {
  useSEO("Page Not Found — SSDE LTD", "The page you are looking for could not be found.");
  return (
    <section className="bg-offwhite min-h-[80vh] flex items-center pt-24" data-testid="not-found-page">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 text-center w-full">
        <p className="eyebrow mb-5">Error 404</p>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-charcoal">
          This page has<br className="hidden sm:block" /> wandered off.
        </h1>
        <p className="mt-6 text-base text-charcoal-mute max-w-md mx-auto leading-relaxed">
          The page you are looking for doesn't exist or may have been moved.
        </p>
        <Link to="/" className="btn-gold mt-9" data-testid="not-found-home-button">
          <ArrowLeft size={15} strokeWidth={1.8} />
          Back to Home
        </Link>
      </div>
    </section>
  );
};

export default NotFound;
